import { render } from "./PvtParamConfigModal.vue?vue&type=template&id=1295e7f4"
import script from "./PvtParamConfigModal.vue?vue&type=script&lang=js"
export * from "./PvtParamConfigModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__